var _g, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 27,
    viewBox: "0 0 87 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#202020",
    className: "logoText"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2661 22H52.3091V15.278H58.9003V22H62.9351V5.27271H58.9003V11.9865H52.3091V5.27271H48.2661V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5512 5.27271V22H68.488V11.6679H68.6268L72.6453 21.8938H75.1609L79.1794 11.7251H79.3182V22H83.255V5.27271H78.2483L74.0011 15.6292H73.8051L69.5579 5.27271H64.5512Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 27,
    rx: 2,
    fill: "#5D16A6",
    className: "logoBg"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11284 22H10.6611L14.1814 9.47093H14.3121L17.8323 22H20.3724L25.0198 5.27277H22.3572L19.1064 18.2348H18.9513L15.5617 5.27277H12.9317L9.54217 18.2266H9.38699L6.12811 5.27277H3.47363L8.11284 22Z",
    fill: "white",
    className: "logoTextBg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.205 22H28.6471V9.45459H26.205V22ZM27.4383 7.51887C28.2796 7.51887 28.982 6.86546 28.982 6.06503C28.982 5.2646 28.2796 4.60303 27.4383 4.60303C26.5889 4.60303 25.8946 5.2646 25.8946 6.06503C25.8946 6.86546 26.5889 7.51887 27.4383 7.51887Z",
    fill: "white",
    className: "logoTextBg"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4135 12.5174C39.9071 10.5654 38.3797 9.29124 35.6681 9.29124C32.8339 9.29124 30.8247 10.7859 30.8247 13.0075C30.8247 14.788 31.9028 15.9723 34.2551 16.4951L36.3787 16.9606C37.5875 17.2302 38.151 17.7692 38.151 18.5533C38.151 19.5253 37.1137 20.2848 35.5129 20.2848C34.0509 20.2848 33.1116 19.6559 32.8176 18.4226L30.4571 18.782C30.8655 21.0036 32.7114 22.2532 35.5292 22.2532C38.5594 22.2532 40.6585 20.6442 40.6585 18.3736C40.6585 16.6013 39.5314 15.5068 37.2281 14.9759L35.2352 14.5185C33.8549 14.1918 33.2586 13.7263 33.2668 12.8768C33.2586 11.913 34.3041 11.227 35.6926 11.227C37.2118 11.227 37.9142 12.0682 38.2 12.9095L40.4135 12.5174Z",
    fill: "white",
    className: "logoTextBg"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7d2fe883e529152604411c3c3cd1b9b6.svg";
export { ForwardRef as ReactComponent };